import React, { useState, useEffect, useRef } from 'react';
import style from './SurgeryMore.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';


const SurgeryMore = () => {

    
    return (
        <>
            <HeadSub title="주요 수술/처치력" />

                <div id="sub-content">
                    <div className='inner-wrap' data-pad="normal">

                        <div className={style['surgery-list-box']}>
                            <ul>
                                <li>
                                    <p>인공관절치환술</p>
                                    <div className={style['span-box']}>
                                        <span>24.11.02</span>
                                        <span>여의도성모</span>
                                    </div>
                                </li>
                                <li>
                                    <p>%수술명, 처치명%</p>
                                    <div className={style['span-box']}>
                                        <span>24.11.02</span>
                                        <span>여의도성모</span>
                                    </div>
                                </li>
                                <li>
                                    <p>%수술명, 처치명%</p>
                                    <div className={style['span-box']}>
                                        <span>24.11.02</span>
                                        <span>여의도성모</span>
                                    </div>
                                </li>
                                <li>
                                    <p>%수술명, 처치명%</p>
                                    <div className={style['span-box']}>
                                        <span>24.11.02</span>
                                        <span>여의도성모</span>
                                    </div>
                                </li>

                                <li>
                                    <p>%수술명, 처치명%</p>
                                    <div className={style['span-box']}>
                                        <span>24.11.02</span>
                                        <span>여의도성모</span>
                                    </div>
                                </li>
                            </ul>
                        </div>        

                    </div>
                </div>
                
            
        </>
    );
};

export default SurgeryMore;
